import React from 'react';
import { connect } from 'react-redux';
import BasePage from '../../baseClasses/BasePage';
import TaskDetailWrapper from '../TaskDetailWrapper';

export class TaskDetailDirectWrapper extends BasePage {

  render() {
    return (
      <TaskDetailWrapper {...this.props} rootPage={true} />
    );
  }

}

export default connect()(TaskDetailDirectWrapper);



// WEBPACK FOOTER //
// ./src/mobileWrappers/TaskDetailDirectWrapper/index.js